var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Loading',{attrs:{"hideInside":false,"state":_vm.loading}},[_c('div',{staticClass:"auth"},[(_vm.loading)?[_vm._v("Выход из системы...")]:[_c('a',{attrs:{"href":"/"}},[_vm._v("Войти в систему...")])]],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }